import {Component, Input, OnInit, ViewChild, AfterViewInit} from "@angular/core";
import {EventComponent} from "../events/events.component";

@Component({
    moduleId: module.id,
    selector: 'event-info',
    templateUrl: 'event-info.component.html',
    providers: []
})
export class EventInfoComponent implements AfterViewInit {
    @Input() events: any;
    date: Date;
    @ViewChild(EventComponent, {static: false}) eventInfo: EventComponent;

    ngAfterViewInit(): void {
        this.eventInfo.bindLocal(this.events);
    }

    rebindLocal(data) {
        this.eventInfo.bindLocal(data);
        if (data.length > 0) {
            if(data[0].EventDate === undefined){
                this.date = data[0].Date;
            }
            else{
                this.date = data[0].EventDate;
            }
            
        }
    }

}